// Copyright (c) Move Closer 2022.

import { logger } from '../../../../support'

import { DictionaryServiceType, IDictionaryService } from '../../services/dictionary'
import { StoreConfigServiceType, IStoreConfigService } from '../../services/store-config'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl> (original)
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (edited)
 */
export const SetupPlugins: any = {
  async created (context: any) {
    const dictionaryService: IDictionaryService = context.app!.$container!.get(DictionaryServiceType)
    const storeConfigService: IStoreConfigService = context.app!.$container!.get(StoreConfigServiceType)

    try {
      await dictionaryService.loadCountries()
      await storeConfigService.loadConfig()
    } catch (e) {
      logger(e, 'error')
    }
  }
}
